import React from "react";

/*
    Language Icon
    props:
        - title: string, override the default title 'Language'
        - color: string, override the default color '#00549A' (bell blue)
        - lang: string, 'en' or 'fr' display english or french icons (default 'fr')
*/

const LanguageIcon = (props) => (
    <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Language"}</title>
        <path
            d="M20.25 3.75H3.75V15.5H6.5V20.25L10.75 15.5H20.25V3.75Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        {props.lang.indexOf("en") === 0 ? (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.75 12.9028V7.70145C6.75 7.16348 6.91852 6.75515 7.25556 6.47645C7.59259 6.19774 8.04953 6.05839 8.62639 6.05839H10.8819V7.08895H8.53889C8.12407 7.08895 7.91667 7.30607 7.91667 7.74033V8.84867H10.5611V9.87922H7.91667V11.8723H11.0569V12.9028H6.75ZM16.5046 13C16.0379 13 15.6847 12.7732 15.4449 12.3194L12.9462 7.40972V12.9028H11.8379V6.93333C11.8379 6.66759 11.9157 6.4456 12.0712 6.26736C12.2268 6.08912 12.4472 6 12.7324 6C13.2185 6 13.5944 6.25602 13.8601 6.76806L16.3004 11.5806V6.05833H17.4087V12.0667C17.4087 12.3389 17.3293 12.5625 17.1705 12.7375C17.0118 12.9125 16.7898 13 16.5046 13Z"
                fill={props.color || "#00549A"}
            />
        ) : (
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7731 13L14.3592 10.6172C14.2735 10.4656 14.1862 10.3618 14.0972 10.3058C14.0082 10.2498 13.8945 10.2218 13.7561 10.2218H13.0739V13H11.8677V7.56215C11.8677 6.52071 12.4774 6 13.6968 6H14.2208C14.9195 6 15.4979 6.17961 15.956 6.53884C16.4141 6.89807 16.6431 7.41713 16.6431 8.09605C16.6431 8.9727 16.2114 9.60216 15.3479 9.98446L17.1869 13H15.7731ZM8.81921 7.08802C8.40395 7.08802 8.19633 7.30883 8.19633 7.75045V8.83802H10.8164V9.88605H8.19633V13.0005H7V7.7109C7 7.17041 7.17137 6.75681 7.51412 6.47008C7.85688 6.18336 8.32156 6.04 8.90819 6.04H11.202V7.08802H8.81921ZM15.0315 7.31009C15.2688 7.48476 15.3875 7.75006 15.3875 8.10599C15.3875 8.44215 15.2771 8.7058 15.0562 8.89695C14.8354 9.0881 14.5372 9.18367 14.1615 9.18367H13.0739V7.57209C13.0739 7.22275 13.2552 7.04808 13.6177 7.04808H14.1021C14.4844 7.04808 14.7942 7.13541 15.0315 7.31009Z"
                fill={props.color || "#00549A"}
            />
        )}
    </svg>
);

export default LanguageIcon;
